import React, { useState, useEffect } from 'react';

// Libraries
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { Navigation, A11y } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

// Components
import PageHeader from '../../layouts/page-header/PageHeader';
import SectionTitle from '../../component/section-title/section-title';
import TeamSection from '../../template/team-section';
import TeamStyle1 from '../../component/team/team-item';
import TestimonialStyle1 from '../../component/testimonial/testimonial-item';
import ClientLogo from '../../component/client-logo';
import { ServiceBoxStyle2 } from '../../component/service-box/service-box';

// SIte Data
import TeamList from '../../data/team-list';
import TestimonialList from '../../data/testimonial-list';
import { AwardLogoList } from '../../data/client-logo-list';
import HOTELList from '../../data/hotel-data';

function HotelConve() {
  const [columns, setColumns] = useState(4); // Default to 4 columns

  useEffect(() => {
    const updateColumns = () => {
      const width = window.innerWidth;
      if (width >= 1024) {
        setColumns(4); // 4 columns for large screens
      } else if (width >= 768) {
        setColumns(3); // 3 columns for medium screens
      } else if (width >= 480) {
        setColumns(2); // 2 columns for small screens
      } else {
        setColumns(1); // 1 column for very small screens
      }
    };

    // Call on mount to set initial columns
    updateColumns();

    // Listen for window resizing and update columns
    window.addEventListener('resize', updateColumns);

    // Cleanup the event listener
    return () => window.removeEventListener('resize', updateColumns);
  }, []);

  return (
    <>
      <div className="site-content">
        <PageHeader
          title="Le Conseil d'Administration"
          breadCrumbItems={[
            { label: 'Accueil', path: '/' },
            // { label: 'Our Team', path: '#', active: true },
          ]}
        />
        <div className="content-wrapper">
          <section className="section-ptb">
            <Container>
              <Row className="justify-content-center">
                <Col sm={8}>
                  <SectionTitle
                    extraClass="text-center"
                    title="Hôtels partenaires"
                    manyContent={[
                      'La Chambre de Commerce et d’Industrie Tuniso-Suisse bénéficie de protocoles d’accord avec plusieurs hôtels prestigieux en Tunisie, offrant à ses membres des avantages exclusifs pour leurs séjours, événements professionnels et rencontres d’affaires.Nous remercions nos partenaires hôteliers pour leur confiance :',
                    ]}
                  />
                </Col>
                <Col sm={12}>
                  <div
                    className="team-wrapper grid-wrapper grid-lg-3 grid-md-3 grid-sm-3 grid-xs-1 mb-5"
                    style={{
                      display: 'grid',
                      gridTemplateColumns: `repeat(${columns}, 1fr)`, // Dynamically set number of columns
                      gap: '0', // Remove space between grid items
                      padding: '0', // Ensure there's no padding around the grid
                    }}
                  >
                    {HOTELList.map((val, item) => {
                      if (item < 12) {
                        return (
                          <div className="team" style={{ border: '1px solid #ddd' }}>
                          <div className="team-img-1 mt-2">
                            <img
                              src={val.img}
                              alt=""
                              style={{ width: '100%', height: '250px' }}
                              className="img-fluid  "
                            />
                          </div>
                          <div className="team-info mb-2">
                              <a 
                              href={val.url} 
                              target="_blank" 
                              rel="noopener noreferrer"
                              style={{ textDecoration: 'none', color: 'inherit' }}
                            >
                              <h6>
                              <b>          {val.name}
                              </b>
                            </h6>
                            </a>
                            
                            
                          </div>
                        </div>
                        );
                      }
                      return null;
                    })}
                  </div>
                </Col>
                 <Col sm={8}>
                  <SectionTitle
                    extraClass="text-center mt-5"
                    manyContent={[
                      'Les membres de la CCITNCH peuvent bénéficier d’offres préférentielles dans ces établissements partenaires. Pour plus d’informations, veuillez nous contacter par e-mail : chambretunisosuisse@gmail.com'
                    ]}
                  />
                </Col>
              </Row>
            </Container>
          </section>
        </div>
      </div>
    </>
  );
}

export default HotelConve;
